var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavPayroll(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Invoice",
    d: "M367-442a9,9,0,0,1,9-9,9,9,0,0,1,9,9,9,9,0,0,1-9,9A9,9,0,0,1,367-442Zm1.331,0a7.678,7.678,0,0,0,7.67,7.67A7.678,7.678,0,0,0,383.67-442a7.678,7.678,0,0,0-7.669-7.67A7.678,7.678,0,0,0,368.331-442Zm7.237,5.448v-1.316h-2.307a.665.665,0,0,1-.665-.666.665.665,0,0,1,.665-.665h2.307v-2.137h-.573a2.4,2.4,0,0,1-2.4-2.4,2.4,2.4,0,0,1,2.4-2.4h.573v-1.316a.665.665,0,0,1,.665-.665.665.665,0,0,1,.666.665v1.316h1.812a.665.665,0,0,1,.665.665.665.665,0,0,1-.665.665H376.9v2.137h.573a2.4,2.4,0,0,1,2.4,2.4,2.4,2.4,0,0,1-2.4,2.4H376.9v1.316a.666.666,0,0,1-.666.666A.665.665,0,0,1,375.568-436.551ZM376.9-439.2h.573a1.07,1.07,0,0,0,1.068-1.069,1.07,1.07,0,0,0-1.068-1.069H376.9Zm-2.972-4.536a1.07,1.07,0,0,0,1.068,1.069h.573V-444.8h-.573A1.07,1.07,0,0,0,373.926-443.734Z",
    transform: "translate(-367 451)",
    fill: "#333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavPayroll);
export default __webpack_public_path__ + "static/media/Nav-Payroll.d0e2c66f9687b0662b5365f4eea710fc.svg";
export { ForwardRef as ReactComponent };